<template>
  <div class="px-4 py-3">
    <!-- Header -->
    <div class="flex justify-between items-center border-b border-gray-200 py-4 mb-6">
      <h1 class="text-xl font-semibold text-gray-800">Mes Factures</h1>
      <div class="flex flex-row sm:items-center sm:space-x-2">
      </div>
    </div>

    <!-- Cards -->
    <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-8">
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Total Factures</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <i class="fas fa-file-invoice text-gray-600"></i>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ totalFactures }}</div>
        </div>
      </div>

      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">En Attente</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <i class="fas fa-hourglass-half text-gray-600"></i>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ facturesEnAttente }}</div>
        </div>
      </div>

      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Payées</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <i class="fas fa-check text-gray-600"></i>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ facturesPayees }}</div>
        </div>
      </div>

      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">En Retard</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <i class="fas fa-exclamation-triangle text-gray-600"></i>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ facturesEnRetard }}</div>
        </div>
      </div>
    </div>

    <!-- Tableau des factures -->
    <div class="overflow-x-auto bg-white shadow-sm rounded-2xl border border-gray-100">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Numéro</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Devis</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Objet</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Statut</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Montant</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Action</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
       <tr v-for="facture in facturesPaginated" :key="facture.id">

            <td class="px-6 py-4 text-sm text-gray-900">{{ facture.numero }}</td>
            <td class="px-6 py-4 text-sm text-gray-900">{{ facture.projet }}</td>
            <td class="px-6 py-4 text-sm text-gray-900">{{ facture.objet }}</td>
            <td class="px-6 py-4 text-sm text-gray-500">{{ facture.date }}</td>
            <td class="px-6 py-4 text-sm">
              <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" :class="statutClass(facture)">
                {{ facture.statut }}
              </span>
            </td>
            <td class="px-6 py-4 text-sm text-gray-900">{{ facture.montant }} €</td>
            <td class="px-6 py-4 text-sm flex gap-2 items-center">
              <!-- Marquer comme payé -->
              <button
                v-if="facture.statut !== 'payée'"
                @click="marquerPayee(facture)"
                class="px-3 py-1 bg-green-50 text-green-700 rounded hover:bg-green-100 transition text-xs font-medium"
              >
                Marquer comme Payée
              </button>
              <button
                v-else
                disabled
                class="px-3 py-1 bg-gray-100 text-gray-400 rounded text-xs font-medium"
              >
                Achat effectué
              </button>

              <!-- Télécharger -->

            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Pagination -->
<div class="flex gap-4 justify-end items-center mt-4">
  <button @click="prevPage" :disabled="currentPage === 1"
    class="flex items-center gap-1 px-3 py-2 border rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
    </svg>
  </button>

  <button v-for="page in totalPages" :key="page" @click="goToPage(page)"
    :class="['px-3 py-2 rounded-full', page === currentPage ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-100']">
    {{ page }}
  </button>

  <button @click="nextPage" :disabled="currentPage === totalPages"
    class="flex items-center gap-1 px-3 py-2 border rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
    </svg>
  </button>
</div>

  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import axios from 'axios'

const totalFactures = ref(0)
const facturesEnAttente = ref(0)
const facturesPayees = ref(0)
const facturesEnRetard = ref(0)
const factures = ref([])

// Pagination
const currentPage = ref(1)
const pageSize = ref(5) // nombre de factures par page
const totalPages = computed(() => Math.ceil(factures.value.length / pageSize.value))

// Factures paginées
const facturesPaginated = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value
  const end = start + pageSize.value
  return factures.value.slice(start, end)
})

// Pagination controls
const prevPage = () => { if (currentPage.value > 1) currentPage.value-- }
const nextPage = () => { if (currentPage.value < totalPages.value) currentPage.value++ }
const goToPage = (page) => { if (page >= 1 && page <= totalPages.value) currentPage.value = page }

// Charger les factures depuis le backend
async function loadFactures() {
  try {
    const token = localStorage.getItem('token')
    const { data } = await axios.get('https://datafuseweb-95a5588f8542.herokuapp.com/api/factures', {
      headers: { Authorization: `Bearer ${token}` }
    })
    console.log(data)
    factures.value = data.factures.map(f => ({
      id: f._id,
      numero: f.numeroFacture || '#FAC000',
      projet: f.devisNumero || 'N/A',
      objet: f.objet,
      date: new Date(f.date).toLocaleDateString(),
      statut: f.statut.toLowerCase(),
      montant: f.montant
    }))

    // Mettre à jour les compteurs
    totalFactures.value = factures.value.length
    facturesEnAttente.value = factures.value.filter(f => f.statut === 'en attente').length
    facturesPayees.value = factures.value.filter(f => f.statut === 'payée').length
    facturesEnRetard.value = factures.value.filter(f => f.statut === 'en retard').length
  } catch (err) {
    console.error('Erreur lors du chargement des factures :', err)
  }
}

// Marquer une facture comme payée
async function marquerPayee(facture) {
  if (facture.statut === 'payée') return
  try {
    const token = localStorage.getItem('token')
    await axios.put(`https://datafuseweb-95a5588f8542.herokuapp.com/api/factures/${facture.id}/payer`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    })

    if (facture.statut === 'en attente') facturesEnAttente.value--
    if (facture.statut === 'en retard') facturesEnRetard.value--
    facture.statut = 'payée'
    facturesPayees.value++
  } catch (err) {
    console.error('Erreur lors du paiement de la facture :', err)
    alert("Impossible de marquer la facture comme payée.")
  }
}

// Classe CSS selon le statut
function statutClass(facture) {
  switch (facture.statut) {
    case 'en attente': return 'bg-yellow-100 text-yellow-800'
    case 'payée': return 'bg-green-100 text-green-800'
    case 'en retard': return 'bg-red-100 text-red-800'
    default: return 'bg-gray-100 text-gray-800'
  }
}


onMounted(loadFactures)
</script>

